import React from "react";
import { motion } from "framer-motion";
import "./WhyChooseUs.css";
import { Link } from "react-router-dom";

function WhyChooseUs() {
  return (
    <section className="why-choose-us">
      {/* ===== Left Text Content ===== */}
      <div className="content">
        <h2>Why choose Iklim Digitals as your Marketing partner?</h2>
        <p>
          When you partner with our agency, our team of digital and marketing experts
          takes a marketing approach to elevate your message and your brand. By building
          and growing relationships online, you will see increased traffic with qualified
          and truly engaged leads.
        </p>
        <Link to="/aboutus" className="learn-more">
  Learn More
</Link>

      </div>

     
      <motion.div
        className="image-container"
        initial={{ x: "10vw", opacity: 0 }} 
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ type: "tween", duration: 1.2, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <img src="/assets/iklim logo final.png" alt="Iklim Digitals Logo" />
      </motion.div>
    </section>
  );
}

export default WhyChooseUs;
